import { Send, OctagonX} from "lucide-react";

export default function JoinButton({clubId, userId, username, profileImg, onSendJoinRequest, onCancelJoinRequest, pendingRequests}){
     //set to true to test cancel button
    function handleRequestACB(clubId, userId, username, profileImg){
        console.log("Sending join request for:", clubId, username);
        onSendJoinRequest(clubId, userId, username, profileImg);
    }

  function handleCancelRequestACB(clubId, userId){
    console.log("Cancel join request");
    onCancelJoinRequest(clubId, userId)
  }
  //pendingRequests är en array med userIds från klubbens perspektiv
  console.log("the pendingRequests for club " + clubId + ": " + pendingRequests)
  return !pendingRequests.includes(userId) ? (
    <button onClick={()=>handleRequestACB(clubId, userId, username, profileImg)}
        className="w-full py-2 text-sm font-medium leading-6 bg-gradient-to-r from-blue-500 to-cyan-600 text-white !rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all flex items-center justify-center gap-2"
    >
        <Send className="w-4 h-4" />
        <span>Request to Join</span>
    </button>
  ) : (
    <button onClick={()=>handleCancelRequestACB(clubId, userId)}
        className="w-full py-2 text-sm font-medium leading-6 bg-red-200 text-red-700 !border border-red-300 !rounded-lg hover:bg-red-300 transition-all flex items-center justify-center gap-[1px]"
    >
        <OctagonX className="w-4 h-4 mr-2"/>
        <span>Cancel Request</span>
    </button>
  )
}